import React from 'react';

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="min-h-screen relative flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/login-bg.png')`
        }}
      />
      
      {/* Enhanced Overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/50 to-black/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40" />
      
      {/* Content: two columns on md+ so branding is on the left and form on the right (reduces vertical scroll) */}
      <div className="relative z-10 w-full max-w-3xl flex flex-col md:flex-row md:items-center md:gap-10 lg:gap-12">
        {/* Left: Logo + title + subtitle */}
        <div className="text-center md:text-left mb-6 md:mb-0 md:flex-shrink-0 md:max-w-xs">
          <img
            src="/images/pakpoints.svg"
            alt="PakPoints"
            className="h-12 md:h-14 w-auto mx-auto md:mx-0 mb-3 drop-shadow-lg"
          />
          {title && <h2 className="text-2xl font-semibold text-white drop-shadow-md">{title}</h2>}
          {subtitle && <p className="text-white/90 mt-2 drop-shadow-sm">{subtitle}</p>}
          {/* Footer on left column (md+ only) */}
          <div className="mt-6 md:mt-8 hidden md:block text-sm text-white/80 drop-shadow-sm">
            <p>&copy; 2025 PakPoints. All rights reserved.</p>
          </div>
        </div>

        {/* Right: Auth Form Container */}
        <div className="flex-1 w-full max-w-md">
          <div className="bg-white/95 backdrop-blur-sm py-8 px-6 shadow-2xl rounded-xl border border-white/20">
            {children}
          </div>
          {/* Footer below form on small screens only */}
          <div className="mt-6 text-center md:hidden text-sm text-white/80 drop-shadow-sm">
            <p>&copy; 2025 PakPoints. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
